import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SensorMap from './SensorMap';
import { STATUS_TEXT, levelStatus, sensorPlace } from './levelStatus';
import { subscribeLatestLevels } from './sensorData';

const HomePage = ({ sensors, loading, error, unitSystem }) => {
  const navigate = useNavigate();
  const [mode, setMode] = useState('map');
  const [levels, setLevels] = useState({});
  const [listId, setListId] = useState('');

  useEffect(() => subscribeLatestLevels(
    (next) => setLevels(next),
    (err) => console.error('[Home] waterLevel_latest:', err)
  ), []);

  const openLocation = (id) => {
    if (id) navigate(`/location/${encodeURIComponent(id)}`);
  };

  const choices = [...sensors].sort((a, b) => (
    sensorPlace(a, a.id).title.localeCompare(sensorPlace(b, b.id).title)
  ));

  return (
    <main className="page">
      <div className="intro">
        <div className="intro-copy">
          <h1>Select your location</h1>
          <p>Live flood levels for nearby canals.</p>
        </div>
      </div>

      <div className="segmented mode-toggle" role="group" aria-label="How to choose a location">
        <button type="button" aria-pressed={mode === 'map'} onClick={() => setMode('map')}>
          Live map
        </button>
        <button type="button" aria-pressed={mode === 'list'} onClick={() => setMode('list')}>
          Choose from list
        </button>
      </div>

      {error && <p className="banner-error" role="alert">{error}</p>}

      {mode === 'map' ? (
        <section className="map-card" aria-label="Sensor map">
          {loading ? (
            <div className="map-status">Loading sensors…</div>
          ) : (
            <SensorMap
              sensors={sensors}
              unitSystem={unitSystem}
              levels={levels}
              onSensorSelect={openLocation}
              layoutToken="map"
            />
          )}
        </section>
      ) : (
        <form
          className="location-list"
          onSubmit={(event) => {
            event.preventDefault();
            openLocation(listId);
          }}
        >
          <label htmlFor="sensor-list">Sensor</label>
          <div className="list-row">
            <select
              id="sensor-list"
              value={listId}
              onChange={(event) => setListId(event.target.value)}
            >
              <option value="">Choose a sensor</option>
              {choices.map((sensor) => {
                const latest = levels[sensor.id];
                const status = levelStatus(
                  latest?.levelMm,
                  sensor.yellowMm,
                  sensor.redMm,
                  latest?.atMs
                );
                const name = sensorPlace(sensor, sensor.id).title;
                return (
                  <option key={sensor.id} value={sensor.id}>
                    {`${name} — ${STATUS_TEXT[status].name}`}
                  </option>
                );
              })}
            </select>
            <button type="submit" className="btn btn-primary" disabled={!listId || loading}>
              View
            </button>
          </div>
          {!loading && choices.length === 0 && <p className="chart-note">Not available yet</p>}
        </form>
      )}
    </main>
  );
};

export default HomePage;
